import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '../core';
import { WidgetModule } from '../widget';
import { GroupsComponentsModule } from 'app/groups/groups-components.module';
import { AgentsComponentsModule } from 'app/agents/agents-components.module';
import { StudentsModule } from '../students/students.module';
import { ClientsRoutingModule } from './clients-routing.module';
import { ClientsQuestionsService } from './questions-services/clients-questions.service';
import { ClientsComponent } from './clients/clients.component';
import { ClientsListComponent } from './clients-list/clients-list.component';
import { ClientDeleteComponent } from './client-delete/client-delete.component';
import { ClientDetailComponent } from './client-detail/client-detail.component';
import { ClientEditorComponent } from './client-editor/client-editor.component';
import { ClientCreateComponent } from './client-create/client-create.component';
import { CreditsModule } from '../credits/credits.module';
import { ClientCreditsComponent } from './client-credits/client-credits.component';
import { ClientSubscriptionsComponent } from './client-subscriptions/client-subscriptions.component';
import { ClientPlanEditorComponent } from './client-subscriptions/client-plan-editor/client-plan-editor.component';
import { ClientSsoComponent } from './client-sso/client-sso.component';
import { ClientSftpEditorComponent } from './client-sso/client-sftp-editor/client-sftp-editor.component';
import { ClientSsoEditorComponent } from './client-sso/client-sso-editor/client-sso-editor.component';
import { TechTestComponent } from './tech-test/tech-test.component';
import { TechTestService } from './services/tech-test.service';
import { ClientSubscriptionEditorComponent } from './client-subscriptions/client-subscription-editor/client-subscription-editor.component';
import { PaymentsModule } from '../payments/payments.module';
import { ClientSubscriptionsListComponent } from './client-subscriptions/client-subscriptions-list/client-subscriptions-list.component';
import { CoursesModule } from 'app/courses/courses.module';
import { ItinerariesModule } from 'app/itineraries/itineraries.module';
import { RankingModule } from 'app/ranking/ranking.module';
import { DashboardModule } from 'app/dashboard/dashboard.module';
import { ClientClassesComponent } from './client-classes/client-classes.component';
import { ClientAgentsComponent } from './client-agents/client-agents.component';
import { ClientKeplerDetailComponent } from './client-kepler-detail/client-kepler-detail.component';
import { KeplerModule } from '../kepler/kepler.module';
import { ClientKeplerMatchComponent } from './client-kepler-match/client-kepler-match.component';

@NgModule({
  imports: [
    CommonModule,
    CoreModule,
    AgentsComponentsModule,
    GroupsComponentsModule,
    StudentsModule,
    CreditsModule,
    WidgetModule,
    PaymentsModule,
    ClientsRoutingModule,
    ItinerariesModule,
    RankingModule,
    CoursesModule,
    DashboardModule,
    KeplerModule
  ],
  declarations: [
    ClientsComponent,
    ClientsListComponent,
    ClientDeleteComponent,
    ClientDetailComponent,
    ClientEditorComponent,
    ClientCreateComponent,
    ClientCreditsComponent,
    ClientSubscriptionsComponent,
    ClientSftpEditorComponent,
    ClientSsoComponent,
    ClientSsoEditorComponent,
    TechTestComponent,
    ClientSubscriptionEditorComponent,
    ClientSubscriptionsListComponent,
    ClientPlanEditorComponent,
    ClientClassesComponent,
    ClientAgentsComponent,
    ClientKeplerDetailComponent,
    ClientKeplerMatchComponent
  ],
  exports: [ClientsListComponent],
  providers: [ClientsQuestionsService, TechTestService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ClientsModule {}
